export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  ARCHIVIST: "Archivist",
  OWNER: "Owner",
  MANAGER: "Manager",
  TEAM_MEMBER: "Team Member",
  OBSERVER: "Observer",
} as const;
